import globalUtils from "../../../utils";
import store from "../store";
import service from "../service";
import { Message } from "element-ui";
import canstant from "../constant";
import constant from "../../../constant";
import { Base64 } from "js-base64";
import request from "../utils/request";
import { setSessionTimeCache } from "./message";

import { isApp, backPage } from "./bridge";
import { closeWindows } from "./win";
import { resolveProductId } from "./product-id";

// 系统
export const getDeviceSystem = () => {
  // 0:H5、1:Windows、2:Mac、3:IOS、4:Android
  const agent = navigator.userAgent.toLowerCase();
  if (/windows/.test(agent)) {
    // return "Windows";
    return 1;
  } else if (
    /iphone|ipod/.test(agent) ||
    /ipad/.test(agent) ||
    /mobile/.test(agent)
  ) {
    // return "Ios";
    return 0;
    // return 3;
  } else if (/android/.test(agent) || /mobile/.test(agent)) {
    // return "Android";
    return 0;
    // return 4;
  } else if (/linux/.test(agent)) {
    // return "Linux pc";
    return 0;
  } else if (/mac/.test(agent)) {
    // return "Mac";
    return 2;
  } else {
    // return "other";
    return 0;
  }
};
// 访问浏览器
export const getBrower = () => {
  var browser = {
    versions: (function() {
      var u = navigator.userAgent;
      //移动终端浏览器版本信息
      return {
        trident: u.indexOf("Trident") > -1, //IE内核
        presto: u.indexOf("Presto") > -1, //opera内核
        webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
        iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, //是否iPad
        webApp: u.indexOf("Safari") == -1 //是否web应该程序，没有头部与底部
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
  if (browser.versions.mobile) {
    //判断是否是移动设备打开
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //在微信中打开
      if (browser.versions.android) {
        return "weixin-android";
      }
      if (browser.versions.ios) {
        return "weixin-ios";
      }
    } else if (browser.versions.ios) {
      //在IOS浏览器打开
      return "ios-browser";
    } else if (browser.versions.android) {
      //在安卓浏览器打开
      return "android-browser";
    }
  } else {
    //否则就是PC浏览器打开
    return myBrowser();
  }
};
// pc 浏览器
function myBrowser() {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  var isOpera = userAgent.indexOf("Opera") > -1;
  if (isOpera) {
    return "Opera";
  } //判断是否Opera浏览器
  if (userAgent.indexOf("Firefox") > -1) {
    return "FF";
  } //判断是否Firefox浏览器
  if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  }
  if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  } //判断是否Safari浏览器
  if (
    userAgent.indexOf("compatible") > -1 &&
    userAgent.indexOf("MSIE") > -1 &&
    !isOpera
  ) {
    return "IE";
  } //判断是否IE浏览器
}
function detectOS() {
  const sUserAgent = navigator.userAgent;
  const isWin =
    navigator.platform == "Win32" || navigator.platform == "Windows";
  const isMac =
    navigator.platform == "Mac68K" ||
    navigator.platform == "MacPPC" ||
    navigator.platform == "Macintosh" ||
    navigator.platform == "MacIntel";
  if (isMac) {
    return "Mac";
  }
  const isUnix = navigator.platform == "X11" && !isWin && !isMac;
  if (isUnix) {
    return "Unix";
  }
  const isLinux = String(navigator.platform).indexOf("Linux") > -1;
  if (isLinux) {
    return "Linux";
  }
  if (isWin) {
    const isWin2K =
      sUserAgent.indexOf("Windows NT 5.0") > -1 ||
      sUserAgent.indexOf("Windows 2000") > -1;
    if (isWin2K) {
      return "Win2000";
    }
    const isWinXP =
      sUserAgent.indexOf("Windows NT 5.1") > -1 ||
      sUserAgent.indexOf("Windows XP") > -1;
    if (isWinXP) {
      return "WinXP";
    }
    const isWin2003 =
      sUserAgent.indexOf("Windows NT 5.2") > -1 ||
      sUserAgent.indexOf("Windows 2003") > -1;
    if (isWin2003) {
      return "Win2003";
    }
    const isWinVista =
      sUserAgent.indexOf("Windows NT 6.0") > -1 ||
      sUserAgent.indexOf("Windows Vista") > -1;
    if (isWinVista) {
      return "WinVista";
    }
    const isWin7 =
      sUserAgent.indexOf("Windows NT 6.1") > -1 ||
      sUserAgent.indexOf("Windows 7") > -1;
    if (isWin7) {
      return "Win7";
    }
    const isWin8 =
      sUserAgent.indexOf("Windows NT 6.2") > -1 ||
      sUserAgent.indexOf("Windows NT 6.3") > -1 ||
      sUserAgent.indexOf("Windows 8") > -1;
    if (isWin8) {
      return "Win8";
    }
    const isWin10 =
      sUserAgent.indexOf("Windows NT 10") > -1 ||
      sUserAgent.indexOf("Windows 10") > -1;
    if (isWin10) {
      return "Win10";
    }
  }
  return "未知操作系统";
}

const MobileDetect = require("mobile-detect");
const sysEnvironment = globalUtils.isMobile() ? "" : detectOS();
const phoneModel = globalUtils.isMobile()
  ? new MobileDetect(navigator.userAgent.toLowerCase()).phone()
  : "";
export const getDeviceInfo = () => {
  return {
    clientVersion: "", // 客户端版本
    collectInterfaceName: "chatVC", // 采集界面名称
    cpuNum: 8, // cpu总数
    cpuUse: "", // cpu使用比例
    domainUrl: window.location.host, // 	域名
    imei: "fffffff-c665-0936-ffff-ffffef05ac4a", // IMEI
    // enclosure: "",
    loginPort: "业务平台", // 登录端口
    memory: "5827903488", // 内存信息
    phoneModel, // 手机型号
    // productId: commonCanstant.PRODUCTID,
    productId: sessionStorage.getItem("productId"),
    questionType: "0", // 问题类型
    requestUrl: "", //  发起请求路经
    screenHigh: window.screen.height, // 屏幕高度
    screenWidth: window.screen.width, // 屏幕宽度
    terminal: getDeviceSystem(), // 客户端类别
    sysEnvironment, // 系统环境
    netType: "", // 联网类型
    sdFlag: 0 // 是否有sd卡
  };
};
/**
 * 唤醒场景
 * cusType  ：客户类型( 1 会员 2 游客,4代理) c端传入与创建会话不一致 c端传入1 会员  3 游客 4 代理
 * vipLevel  ：VIP等级 （0:普通用户或者游客，1：VIP等级1 以此类推）
 * enterScene ：默认传0
 * chatType默认0：游客
 * type: 1会员   2游客
 */
export async function getqueryCustomerKey(router) {
  store.commit("setState", { isload: true });
  var link = window.location.search;
  var urlData = {};
  const res = await service.getqueryCustomerKey({
    configKey: "customerNumber"
  });
  let pk = res.data;
  try {
    pk = globalUtils.decryptByDES(pk);
  } catch (err) {
    Message.error("系统繁忙[解密失败]");
    return;
  }
  let theRequest = new Object();
  let strs = [];
  if (link.indexOf("?") != -1) {
    let str = link.substr(1);
    strs = str.split("&");
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }

  let arr = theRequest.configKey;
  var params = globalUtils.RSADncrypt(arr, pk);
  console.log("跳转参数", params);
  if (params.indexOf("null") > 0) {
    Message.error("系统繁忙[解密失败]");
    return false;
  }
  if (params) {
    const newArr = params.split("&");
    newArr.forEach(ele => {
      setDataUrlProps(urlData, ele);
    });

    setMainColor(urlData, store);
    setUrlDataEmbed(urlData);
    setProductId(urlData);

    await getDoMain();

    if (store.state.SysNotice) {
      store.commit("setState", { isload: false });
      return false;
    }

    if (urlData.DoMain) {
      store.commit("setState", { urlDomain: urlData.DoMain });
    }

    // 游客唯一id
    urlData.deviceCode = store.state.deviceCode;
    if (!urlData.userId) {
      setVisitorProps({ urlData, store });
    }

    let data = urlData;
    console.log("唤醒场景", urlData);
    // 用户信息 token 会话是否有效
    const customerInfo = await store.dispatch("collectCustomerInfo", data);
    console.log("customerInfo", customerInfo);
    // 获取服务器时间戳
    await service.queryServerConfig().then(res => {
      if (res) {
        if (res.code == 200 && res.data) {
          sessionStorage.setItem("serverTime", res.data.dateTime);
        }
      }
    });

    if (customerInfo && customerInfo.data) {
      const customerUserId = customerInfo.data.userId;

      setCusInfoToLocal(customerInfo);
      setUrlDataCusInfo(urlData, customerInfo);
      setUrlDataDomain(urlData);
      setSessionTimeCache(customerUserId);

      store.commit("setState", {
        alreadyLogin: true,
        customerInfo: customerInfo.data,
        // hasHistory: true,
        urlData: urlData,
        DoMain: urlData.DoMain,
        hideHeader: urlData.hideHeader
      });
      // token
      store.commit("setState", customerInfo.data);
      // 被拉黑
      if (customerInfo.data.blackFlag === 1) {
        return handleBlackCustomer({ store, router });
      }
    }

    if (!urlData.productId) {
      Message.error("参数错误");
      return false;
    } else {
      let data = {
        ...urlData,
        chatType: 0,
        serverId: "",
        serverName: "乐乐"
      };
      console.log(data.enterScene, "changjing");
      store.state.userId = urlData.userId;
      store.state.userName = urlData.userName;
      store.state.skillId = urlData.skillId;
      // 普通场景
      if (data.enterScene == canstant.WakeUpScene.ordinary) {
        setEnterScene(store);
      } else {
        const noUserId = !urlData.userId || urlData.userId == 0;
        const enterId = parseInt(data.enterScene, 10);
        const isDymaticProxyId = enterId > 7;
        const isProxy =
          data.enterScene == canstant.WakeUpScene.proxy || isDymaticProxyId;
        // const noCodeInRecharge =
        //   data.enterScene == canstant.WakeUpScene.Recharge &&
        //   !urlData.rechargeCode;
        const isSpecial =
          data.enterScene == canstant.WakeUpScene.special || 2002;

        if (noUserId) {
          Message.error("无法获取用户，请您登录");
          return false;
        }

        if (isProxy && !isSpecial) {
          store.commit("setState", {
            chatType: 5
          });
        }
        // else if (noCodeInRecharge) {
        // MessageBox.alert("参数错误", "提示", {
        //   confirmButtonText: "关闭页面",
        //   callback: () => {
        //     closeWindows();
        //   }
        // });
        // // Message.error("参数错误");
        // return false;
        // }
        else {
          switch (parseInt(data.enterScene)) {
            case canstant.WakeUpScene.Recharge: //代客充值
              store.commit("setState", {
                chatType: 1
              });
              data.rechargeCode = canstant.WakeUpScene.Recharge;
              break;
            case canstant.WakeUpScene.NoRechargeGate: //无充值通道
              store.commit("setState", {
                chatType: 1
              });
              break;
            case canstant.WakeUpScene.NotReceived: //充值未到账
            case canstant.WakeUpScene.Reflect: //提现问题
            case canstant.WakeUpScene.Game: //游戏问题
              store.commit("setState", {
                orderNum: data.platformOrder,
                chatType: 2
              });
              break;
          }

          initView({ store, data, router });
        }
      }

      store.commit("setState", {
        isBeforeConnect: false,
        triggerId: data.enterScene,
        enterScene: data.enterScene,
        rechargeCode: urlData.rechargeCode
      });

      //返回1代表有有效会话，回到会话的选择页；回到会话再次调用；开启新会话根据新进场景处理
      //返回2代表无会话，无排队，进入场景0，选择技能；进入场景1，直接创建会话
      //返回3代表排队中，进入排队页；能返回3代表新进入场景和排队场景相同；新进入场景和排队场景不同，后台会清除排队，变为返回2
      console.log(router);
      awakeEnter(router);
    }
  } else if (res.data == "" || res.data == null) {
    Message.error("参数错误");
  } else {
    Message.error("解密错误");
  }

  function initView({ store, data, router }) {
    store
      .dispatch("initChannel", {
        orderImgUrls: "",
        orderNum: data.platformOrder
      })
      .then(() => {
        router.push({ path: "/conversation" });
      });
  }

  function setEnterScene(store) {
    store.commit("setState", {
      triggerId: canstant.WakeUpScene.ordinary,
      enterScene: canstant.WakeUpScene.ordinary
    });
  }

  async function handleBlackCustomer({ store, router }) {
    console.log("自动回复");
    // 获取自动回复消息内容
    const { data: autoReplyMessage } = await service.getAutoReplyMessage({
      type: 4
    });
    console.log("客服繁忙", autoReplyMessage);
    const message = {
      type: constant.MESSAGE_TYPE.MT_TEXT,
      content: autoReplyMessage,
      sendFlag: true,
      chatTime: globalUtils.getTime()
    };
    // 添加消息到聊天界面
    store.commit(
      "chat/addMessage",
      { customerId: store.state.userId, message },
      { root: true }
    );
    //人工客服 // 设置被拉黑
    store.commit("setState", {
      isUploadImg: false,
      isBeforeConnect: false,
      isPerson: true,
      chatType: 0,
      blackFlag: 1,
      isConversation: false
    });
    router.push("/conversation");
    return autoReplyMessage;
  }

  function setUrlDataDomain(urlData) {
    if (
      urlData.DoMain &&
      urlData.DoMain.substr(urlData.DoMain.length - 1, 1) == "/"
    ) {
      urlData.DoMain = urlData.DoMain.substr(0, urlData.DoMain.length - 1);
    }
  }

  function setUrlDataCusInfo(urlData, customerInfo) {
    const {
      data: { userId, userName }
    } = customerInfo;
    urlData.userId = userId;
    urlData.userName = userName;
  }

  function setCusInfoToLocal(customerInfo) {
    Object.keys(customerInfo.data).forEach(key => {
      globalUtils.setProp(key, customerInfo.data[key]);
    });
  }

  function setProductId(urlData) {
    sessionStorage.setItem("productId", urlData.productId);
  }

  function setUrlDataEmbed(urlData) {
    urlData["isEmbedded"] = urlData.isEmbedded || 0; //isEmbedded 1嵌入H5，0 不是嵌入。
  }

  function setMainColor(urlData, store) {
    const mainColor = urlData.mainColor ? urlData.mainColor : "yellow";
    store.dispatch("setTheme", mainColor);
  }

  function setDataUrlProps(urlData, ele) {
    const keyArr = ele.split("=");
    if (keyArr[0] && keyArr[1]) {
      urlData[keyArr[0].trim()] = keyArr[1].trim();
    }
  }

  function setVisitorProps({ urlData, store }) {
    urlData["userName"] = globalUtils.getGuestName();
    urlData["userId"] = "";
    urlData["cusType"] = urlData.cusType ? urlData.cusType : 3;
    urlData["vipLevel"] = 0;
    urlData.deviceCode = store.state.deviceCode;
    urlData["mainColor"] = urlData.mainColor ? urlData.mainColor : "yellow";
    urlData["isEmbedded"] = urlData.isEmbedded ? urlData.isEmbedded : 0;
    urlData["enterScene"] =
      urlData.enterScene && urlData.enterScene != "NaN"
        ? urlData.enterScene
        : 0;
    urlData["type"] = 2;
    urlData["chatType"] = 0;
    urlData["enterPage"] = 0;
  }
}
// 请求域名
export async function getDoMain() {
  const productId = resolveProductId(sessionStorage.getItem("productId"));
  if (!productId) {
    store.commit("setState", { domain: {} });
    request.defaults.baseURL = process.env.VUE_APP_CUST_BASEURL;
    return false;
  }
  sessionStorage.setItem("productId", productId);

  try {
    await handleDomain({ service, request, store });
  } catch (e) {
    try {
      await handleDomain({ service, request, store });
    } catch (e) {
      store.commit("setState", { domain: {} });
      console.log(process.env.VUE_APP_CUST_BASEURL, "process.env.VUE_BASEURL");
      request.defaults.baseURL = process.env.VUE_APP_CUST_BASEURL;
    }
  }

  async function handleDomain({ service, request, store }) {
    let res = await service.getdomain({ platId: productId });
    let domains = {};
    const { API_URL, LOG_URL, WEBSOCKET_URL, NOTICE_URL } = res.data || {};

    domains = {
      API_URL: Base64.decode(API_URL),
      LOG_URL: Base64.decode(LOG_URL),
      // dev/stg 新环境的 socket 域名为 ws.*，域名服务仍回传旧的 chat.*
      WEBSOCKET_URL: Base64.decode(WEBSOCKET_URL).replace(
        /^(wss?:\/\/)chat\.((?:bb|yy)kf(?:dev|stg)\.com)/,
        "$1ws.$2"
      )
    };

    request.defaults.baseURL = Base64.decode(API_URL);

    if (NOTICE_URL) {
      store.commit("setState", {
        SysNotice: true
      });
    } else {
      store.commit("setState", {
        SysNotice: false
      });
    }

    store.commit("setState", { domain: domains });
  }
}
// 禁止左滑
export function forbidMoveLeft() {
  if (isApp()) {
    return;
  }

  let startX, startY;

  document.addEventListener("touchstart", function(e) {
    startX = e.targetTouches[0].pageX;
    startY = e.targetTouches[0].pageY;
  });

  document.addEventListener(
    "touchmove",
    function(e) {
      const moveX = e.targetTouches[0].pageX;
      const moveY = e.targetTouches[0].pageY;
      const isMoveLeft = Math.abs(moveX - startX) > Math.abs(moveY - startY);

      if (isMoveLeft) {
        e.preventDefault();
      }
    },
    { passive: false }
  );
}
// 获取留言配置
export function getcustomer() {
  return service.getCustmessageMessage({ userId: store.state.userId });
}
// 提交留言
export function savecustomerMessage(params) {
  return service.saveCustmessageMessage(params);
}
// 退出排队
async function closePage() {
  if (store.state.SysNotice) {
    closeWindows();
  }

  let result = await service.endQueue({ userId: store.state.userId });

  if (result.success) {
    store.commit("clearAllMessages");
    store.commit("setState", {
      isQueue: false
    });
    closeWindows();
  }

  if (isApp()) {
    backPage();
  }
}
// 更新充值码
export async function updateRecharge() {
  let parmas = {
    userId: store.state.userId,
    rechargeCode: store.state.rechargeCode,
    channelId: store.state.channelId
  };
  await service.rechargeCode(parmas);
}
// 选中订单发送消息
export async function sendOrder(content) {
  var item = content.item;
  store.commit("setState", {
    more: false
  });
  let orderDetail = {
    headTitle: item.headTitle,
    rechargeAccount: item.userName,
    platformOrder: item.activeName,
    orderNumber: item.orderId,
    rechargeMoney: item.amount,
    createTime: item.createDate,
    result: item.result,
    paymentId: item.paymentId,
    usdtAmount: item.paymentId == 1002 ? item.usdtAmount : "",
    lastMsgId: store.state.lastMsgId
  };
  if (item.paymentId == 1002 && item.platformOrder != 3) {
    orderDetail.rechargeNumber = item.usdtAmount;
  }
  if ([1, 2].includes(parseInt(item.activeName, 10))) {
    orderDetail.rechargeType = item.paymentName;
  } else if (item.activeName == 3) {
    orderDetail.win = item.win;
    orderDetail.winLose = item.winLose;
    orderDetail.createTime = item.createTime;
    orderDetail.rechargeType = item.channelName;
    orderDetail.result = item.winLose + "(" + item.win + ")";
  }
  switch (item.status) {
    case 0:
      if (item.activeName == 1) {
        orderDetail.orderStatus = "充值中";
      } else if (item.activeName == 2) {
        orderDetail.orderStatus = "提现中";
      } else if (item.activeName == 3) {
        orderDetail.orderStatus = "未结算";
      }
      break;
    case 1:
      if (item.activeName == 3) {
        orderDetail.orderStatus = "已结算";
      } else {
        orderDetail.orderStatus = "已完成";
      }

      break;
    case 2:
      if (item.activeName == 3) {
        orderDetail.orderStatus = "已取消";
      } else {
        orderDetail.orderStatus = "失败";
      }

      break;
    case 3:
      orderDetail.orderStatus = "无效订单";

      break;
  }
  store.dispatch(
    "chat/sendMessage",
    {
      orderList: content.orderList,
      channelId: this.channelId,
      orderDetail,
      type: 17,
      isOrder: true
    },
    { root: true }
  );
  store.commit("setState", { lastMsgId: "" });
}
// 查询订单
export async function getOrder(orderId) {
  let parmas = {
    userId: store.state.userId,
    orderId: orderId,
    serverId: store.state.serverId,
    orderFlag: true
  };
  let orderDetail = await service.getOrder(parmas);
  return orderDetail;
}
export function awakeEnter(router) {
  let res = store.state.customerInfo;
  // 无效会话
  if (res.invalidFlag == canstant.invalidFlag.invalid) {
    const {
      ordinary,
      Recharge,
      Reflect,
      NotReceived,
      Game,
      proxy
    } = canstant.WakeUpScene;
    const { enterScene, cusType } = store.state.urlData;

    const isOrdinaryScene = enterScene == ordinary;
    const isRechargeScene =
      (cusType != 3 &&
        [Recharge, Reflect, NotReceived, Game].includes(
          parseInt(enterScene, 10)
        )) ||
      enterScene == proxy;

    const isProxyClientId = enterScene > 7;

    // 普通场景
    if (isOrdinaryScene) {
      store.dispatch("init", store.state.urlData).then(() => {
        router.push("/before-page");
      });
      // 充值场景
    } else if (isRechargeScene) {
      store.dispatch("initChannel", {
        orderImgUrls: "",
        platformOrder: store.state.orderNum,
        router: router
      });
    } else if (isProxyClientId) {
      store.commit("setState", {
        channelId: res.channelId,
        chatType: res.chatType,
        type: res.type,
        userId: res.userId,
        userName: res.userName
      });
      store.dispatch("initChannel", {
        orderImgUrls: "",
        platformOrder: store.state.orderNum,
        router: router
      });
    } else {
      store.dispatch("init", store.state.urlData).then(() => {
        router.push("/before-page");
      });
    }
    // 有效会话
  } else if (
    res.invalidFlag == canstant.invalidFlag.Effective &&
    res.showNewChannelDialog === true
  ) {
    store.commit("setState", {
      dialogVisible: true,
      showNewChannelDialog: true,
      isload: false,
      isShowEvaluatePage: false
    });
    router.push({ path: "/conversation" });
  } else if (
    res.invalidFlag == canstant.invalidFlag.Effective &&
    res.showNewChannelDialog === false
  ) {
    store.commit("setState", {
      dialogVisible: false,
      showNewChannelDialog: false,
      isload: false,
      isShowEvaluatePage: false
    });
    router.push({ path: "/conversation" });
  }
  //新进入场景和排队场景相同，后台才会返回排队中
  else if (res.invalidFlag == canstant.invalidFlag.queueing) {
    store.commit("setState", {
      channelId: res.channelId,
      chatType: res.chatType,
      type: res.type,
      userId: res.userId,
      userName: res.userName
    });
    store.dispatch("initChannel", {
      orderImgUrls: "",
      platformOrder: store.state.orderNum,
      router: router
    });
  }
}
// 回到底部
export function scrollToBottom() {
  window.messageBox = messageBox;
  const messageBox = document.querySelector("#messageBox");
  messageBox.scrollTop = messageBox.scrollHeight + 200;
  scrollBy(0, messageBox.scrollHeight);
  document.body.scrollTop = messageBox.scrollHeight;
}
// 判断是否清空了缓存
export function isclear() {
  if (
    !sessionStorage.getItem("productId") ||
    !localStorage.getItem("userName")
  ) {
    Message.error("登录已失效,请重新进入 ");
  }
}
//浏览器最小化息屏重启逻辑
export async function reEnter({ refreshActiveHistory = true } = {}) {
  let urlData = {};
  urlData.productId = sessionStorage.getItem("productId");
  await getDoMain();
  if (store.state.SysNotice) {
    store.commit("setState", { isload: false });
    return false;
  }
  // 1：有效会话 2：无效会话 3：排队中"
  if (store.state.blackFlag != 0) {
    return false;
  }
  let data = service.getquerySessionValid({
    userId: store.state.userId,
    enterScene: parseInt(store.state.enterScene)
  });
  const constat = canstant;
  data.then(res => {
    //返回1（有效会话）
    //排队页唤醒：进入会话页
    //chat页唤醒：进入会话页（多段确认）
    if (res.data.invalidFlag == constat.invalidFlag.Effective) {
      const activeScopeChanged =
        String(store.state.userId) !== String(res.data.userId) ||
        String(store.state.channelId) !== String(res.data.channelId);
      const shouldRefreshHistory = refreshActiveHistory || activeScopeChanged;
      store.commit("setState", {
        isConversationEnd: false,
        isConversation: true,
        isShowEvaluatePage: false,
        // isQueue: false,
        ...(shouldRefreshHistory
          ? { isShowHistoryBtn: false, hasHistory: false, beginTime: 0 }
          : {}),
        userId: res.data.userId,
        channelId: res.data.channelId
      });
      if (shouldRefreshHistory) {
        store.dispatch("getMessages", { userId: res.data.userId });
      }
      if (store.state.isQueue) {
        store.dispatch("initChannel", {
          orderImgUrls: ""
        });
        store.commit("setState", {
          isQueue: false
        });
      }
      if (store.state.enterScene == constat.WakeUpScene.Recharge) {
        updateRecharge();
      }
      return false;
    }
    //返回2（无效会话，分排队页面和chat页面进入）
    //排队页唤醒：排队超时
    //chat页唤醒：chat结束页
    if (
      res.data.invalidFlag == constat.invalidFlag.invalid &&
      !store.state.isQueue
    ) {
      // store.dispatch("getMessages", { userId: store.state.userId });
      store.commit("setState", {
        isConversationEnd: true,
        isConversation: false,
        isShowEvaluatePage: true,
        isQueue: false,
        isShowHistoryBtn: false,
        hasHistory: false,
        beginTime: 0
      });
      store.dispatch("getMessages", { userId: store.state.userId });
      return false;
    } else if (
      res.data.invalidFlag == constat.invalidFlag.invalid &&
      store.state.isQueue
    ) {
      store.commit("setState", {
        isConversation: false,
        dialogtime: true,
        dialogVisible: false,
        channeltime: false
      });
    }
    //返回3排队中,排队页面唤醒不做处理，继续返回排队页面；chat页面唤醒不会返回3，多端可能出(chat页隐藏，sdk到了排队)，
    //后台村这个用户就是排队，此时会返回3，你们需要多端和技术确认是否有，有则进入排队（待确认token）;
  });
}
// 自動發送訊息
export function autoSendMessage(messages) {
  if (store.state.channelId && store.state.socketStatus) {
    const messagesArray = messages.split(",");
    messagesArray.forEach(messageText => {
      store.dispatch(
        "chat/sendMessage",
        {
          type: constant.MESSAGE_TYPE.MT_TEXT,
          content: decodeURIComponent(messageText),
          channelId: store.state.channelId,
          socketStatus: store.state.socketStatus
        },
        { root: true }
      );
    });
  } else {
    setTimeout(() => {
      autoSendMessage(messages);
    }, 1000);
  }
}
export default {
  ...globalUtils,
  getDeviceSystem,
  sysEnvironment,
  getDeviceInfo,
  getBrower,
  getqueryCustomerKey,
  closePage,
  updateRecharge,
  getOrder,
  reEnter,
  awakeEnter,
  isclear,
  getDoMain,
  getcustomer,
  savecustomerMessage,
  forbidMoveLeft,
  scrollToBottom,
  sendOrder,
  autoSendMessage
};
